'use strict';

const React = require('react');
const { MinorTeaserArea, MajorTeaserArea } = require('../Teaser');
const { Map } = require('immutable');
const BottomTeasers = ({editorials, otherEditorials}) => {

	if( (editorials || Map()).isEmpty() && (otherEditorials || Map()).isEmpty() ) {
		return (<noscript/>);
	}
	
	return (
			<section className="svtse_section">
				<div className="svtse_bottom-teasers">
					<h1 className="svtse_bottom-teasers__header">Mer från SVT</h1>
					<MajorTeaserArea model={editorials}/>
					<MinorTeaserArea model={otherEditorials}/>
				</div>
			</section>
	);
};

module.exports = BottomTeasers;



/** WEBPACK FOOTER **
 ** ./app/components/FirstpageHandler/BottomTeasers.js
 **/